import React from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
class BannerTwo extends React.Component {
  render() {
    return (
      <div className="before-footer my-3">
        {this.props.banners && this.props.banners.length > 0 && (
          <Link to={this.props.banners && this.props.banners[0].bannerUrl1}>
            <LazyLoadImage
              effect="blur"
              src={`${
                this.props.banners &&
                this.props.banners[0].images &&
                this.props.banners[0].images[1]
              }`}
              alt=""
              height="200px"
              width="200px"
              className="bor-rad-8"
            />
          </Link>
        )}
      </div>
    );
  }
}

export default BannerTwo;
